
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */


const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Le Covid-19 passe par trois phases. Une personne saine devient `}<strong parentName="p">{`infectée`}</strong>{` si
le virus parvient à s'installer dans son organisme, par exemple en passant par
les muqueuses. Mais le sujet n'est pas encore contagieux pour les autres – ce
n'est le cas que quelques jours plus tard. Une personne `}<strong parentName="p">{`contagieuse`}</strong>{` peut
alors propager le virus sans ressentir aucun symptôme. Cette phase passe
inaperçue et peut durer plusieurs jours, c'est pourquoi l'épidémie de Covid-19
est si difficile à arrêter. Lorsque les premiers symptômes apparaissent enfin,
on se sent `}<strong parentName="p">{`malade`}</strong>{`. Plus de 99% des personnes infectées se rétablissent (et
sont probablement immunisées pendant un certain temps et ne peuvent donc plus
être contagieuses). Malheureusement, entre cinq et dix personnes sur mille
meurent.`}</p>
    <p><strong parentName="p">{`Démarrez votre parcours dans la nouvelle normalité!`}</strong></p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;